import type { InvoiceEntry } from '../../../hooks/invoice/useInvoicesFeed';
import { INVOICE_REASON_FLAG_CONFIG, NUMERIC_REASON_BADGE_SCHEME } from '../../../components/invoice/invoiceReasonFlagConfig';
import { getNexHttpReasonBadgeCopy } from '../../../utils/nexHttpReasonBadge';
import {
    getInvoiceNexIdentifierUi,
    type NexReconciliationIdentifierMode,
} from '../../../utils/invoiceNexIdentifierUi';

export const getInvoiceReasonBadges = (
    invoice: InvoiceEntry,
    nexMode: NexReconciliationIdentifierMode,
) => {
    const flags = invoice.reasonFlags;
    const idUi = getInvoiceNexIdentifierUi(nexMode);
    const badges: Array<{ key: string; label: string; colorScheme: string; tooltip: string }> = [];
    if (flags) {
        if (flags.ro) {
            badges.push({
                ...INVOICE_REASON_FLAG_CONFIG.ro,
                label: idUi.reasonBadgeLabel,
                tooltip: idUi.reasonBadgeTooltip,
            });
        }
        if (flags.nex) badges.push(INVOICE_REASON_FLAG_CONFIG.nex);
        if (flags.math) badges.push(INVOICE_REASON_FLAG_CONFIG.math);
        if (flags.dupe) badges.push(INVOICE_REASON_FLAG_CONFIG.dupe);
        if (flags.vendor) badges.push(INVOICE_REASON_FLAG_CONFIG.vendor);
        if (flags.specialVendor) badges.push(INVOICE_REASON_FLAG_CONFIG.specialVendor);
        if (flags.locationMismatch) badges.push(INVOICE_REASON_FLAG_CONFIG.locationMismatch);
        if (flags.stale) badges.push(INVOICE_REASON_FLAG_CONFIG.stale);
        if (flags.price) badges.push(INVOICE_REASON_FLAG_CONFIG.price);
        if (flags.discount) badges.push(INVOICE_REASON_FLAG_CONFIG.discount);
        if (flags.qty) badges.push(INVOICE_REASON_FLAG_CONFIG.qty);
        if (flags.total) badges.push(INVOICE_REASON_FLAG_CONFIG.total);
    }
    for (const code of invoice.reasonCodes ?? []) {
        const { label, tooltip } = getNexHttpReasonBadgeCopy(code);
        badges.push({
            key: `http-${code}`,
            label,
            colorScheme: NUMERIC_REASON_BADGE_SCHEME,
            tooltip,
        });
    }
    return badges;
};
